module.exports = "<div class=\"ngb-modal\">\n  <div class=\"modal-header\">\n    <div class=\"close\">\n      <i class=\"material-icons\" (click)=\"close()\">close</i>      \n    </div>\n  </div>\n  <div class=\"modal-body\">\n    <img [src]=\"domSanitizer.bypassSecurityTrustUrl(imageSrc)\">\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/image-preview/image-preview.component.html
// module id = ./src/app/image-preview/image-preview.component.html
// module chunks = main